<!-- MFITTで予約数が上限に達している場合 -->
<template>
  <ItemDialog ref="overResavationLimit" image-type="alert">
    <template #content-area>
      <h2>予約制限中です</h2>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogOverResavationLimit",
  setup() {
    const overResavationLimit = ref(null);

    const openDialog = () => {
      overResavationLimit.value.open();
    };

    const closeDialog = () => {
      overResavationLimit.value.close();
    };

    return {
      overResavationLimit,
      openDialog,
      closeDialog,
    };
  },
};
</script>
